/**
 * CUSTOMIZATIONS:
 * added Sticky menu
 * header tag added as main container
 * role and aria-label for header-right (HeaderBanner)
 * search input moved into HeaderBanner
 **/
import React, { useState, useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Navigation } from '@plone/volto/components';
import { HeaderBanner } from '@redturtle/volto-io-studio/components/Layout';

const Header = ({ pathname }) => {
  const [sticky, setSticky] = useState(false);

  useEffect(() => {
    const navbar = document.getElementById('navbar');
    const stickyOff = navbar.offsetTop;

    window.onscroll = function () {
      if (window.pageYOffset >= stickyOff) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    };
  }, []);

  return (
    <header className={cx({ 'padding-sticky': sticky })}>
      <HeaderBanner />
      <div className={cx('header-menu', { sticky: sticky })} id="navbar">
        <Container>
          <Navigation pathname={pathname} />
        </Container>
      </div>
    </header>
  );
};

export default Header;

Header.propTypes = {
  token: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  content: PropTypes.objectOf(PropTypes.any),
};

Header.defaultProps = {
  token: null,
  content: null,
};
